var d=Object.defineProperty;var e=(c,a)=>{for(var b in a)d(c,b,{get:a[b],enumerable:!0})};export{e as a};
/*! For license information please see chunk-HZWWJL43.mjs.LEGAL.txt */
//# sourceMappingURL=chunk-HZWWJL43.mjs.map